/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Caution_DescriptionInputs */

const en_orders_review_caution_description = /** @type {(inputs: Orders_Review_Caution_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something is changing on this order.`)
};

const es_orders_review_caution_description = /** @type {(inputs: Orders_Review_Caution_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo esta cambiando en este pedido.`)
};

/**
* | output |
* | --- |
* | "Something is changing on this order." |
*
* @param {Orders_Review_Caution_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_caution_description = /** @type {((inputs?: Orders_Review_Caution_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Caution_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_caution_description(inputs)
	return es_orders_review_caution_description(inputs)
});